import { Select } from '@mantine/core'

import { DisqualifiedReason } from 'src/graphql/types/applicants'
import { formatSnakeValue } from 'src/lib/formatters'

import { inlineSelectProps } from './inlineSelectStyles'

const DisqualifiedReasonOptions = ({
  selectedDisqualifiedReason,
  setSelectedDisqualifiedReason,
}) => {
  const disqualifiedReasonOptions = Object.values(DisqualifiedReason).map(
    (reason) => ({
      value: reason,
      label: formatSnakeValue(reason),
    })
  )

  return (
    <div className="flex flex-col gap-2 text-xs font-medium">      <Select
        {...inlineSelectProps}
        value={selectedDisqualifiedReason?.disqualifiedReason}
        onChange={(value) =>
          setSelectedDisqualifiedReason({ disqualifiedReason: value })
        }
        data={disqualifiedReasonOptions}
        placeholder="Select disqualified reason"
        className="max-w-sm"
        searchable
      />
    </div>
  )
}

export default DisqualifiedReasonOptions
